import { SIDE_LEFT, SIDE_RIGHT } from '../../constants'

export const WIDE_WIDTH = 'WIDE_WIDTH'
export const FULL_WIDTH = 'FULL_WIDTH'

export function extractSide(node) {
  if (!node.matches) {
    return
  }

  if (node.matches('.alignleft, .left')) {
    return SIDE_LEFT
  }

  if (node.matches('.alignright, .right')) {
    return SIDE_RIGHT
  }
}

export function extractAlignment(node) {
  if (node.matches('.alignwide')) {
    return WIDE_WIDTH
  }

  if (node.matches('.alignfull')) {
    return FULL_WIDTH
  }
}

export function getAlignmentProps(node) {
  const side = extractSide(node)
  const alignment = extractAlignment(node)

  if (alignment === FULL_WIDTH || alignment === WIDE_WIDTH) {
    return {
      offset: true,
      padded: alignment === WIDE_WIDTH,
    }
  }

  if (side) {
    return {
      float: side,
    }
  }

  return undefined
}
